export const STATE_PROP = 'machineCleaningArea';
export const GROUP_BY = {
  year: 'year',
  past6Months: 'past6Months',
  month: 'month',
  week: 'week'
};

export const TITLE_TIME = {
  year: 'This Year',
  past6Months: '6 Months',
  month: 'This Month',
  week: 'This Week'
};

export const TITLE_UNIT = {
  cleanedSquareMeter: 'Cleaned Area',
  hours: 'Operating Hours'
};
